<template>
  <div class="all-content-container">
    <portal to="play-filter">
      <div class="filter-header" v-if="$route.params.section === 'clip'" style="display: none"></div>
      <div class="filter-header" v-vue-sticky="{zIndex:1000, stickyTop: 43}" v-else-if="hasFilter">
        <vod-filter-list v-for="(filterItem, index) in filterObject.filterlist"
                         :key="'filter_' + index"
                         :filter-item="filterItem"
                         :filter-title="filterTitleMap[index] || filterItem.title"
                         :base-api="filterObject.baseapi"
                         :filter-index="index"
        ></vod-filter-list>
        <!-- [D] 시즌 필터 스펙 아웃 -->
        <!--        <vod-filter-list v-for="(filterItem, index) in filterObject.filterlist"-->
        <!--                         :key="'filter_' + index"-->
        <!--                         :filter-item="filterItem"-->
        <!--                         :filter-title="filterTitleMap[index] || filterItem.title"-->
        <!--                         :base-api="filterObject.baseapi"-->
        <!--                         :filter-index="index"-->
        <!--        ></vod-filter-list>-->

        <!-- [D] 신규 필터: 토글 시 최신순 / 오래된순 으로 정렬 -->
        <div class="filter">
          <button type="button">최신순</button>
        </div>

        <!--        <span>-->
        <!--          <button type="button" @click="()=>changeFilter('new')" :class="orderFilter === 'new' ? 'old-new on': 'old-new'">-->
        <!--            최신회부터-->
        <!--          </button>-->
        <!--          <button type="button" @click="()=>changeFilter('old')" :class="orderFilter === 'old' ? 'old-new on': 'old-new'">-->
        <!--            첫회부터-->
        <!--          </button>-->
        <!--        </span>-->
      </div>
      <div class="filter-header refresh" v-vue-sticky="{zIndex: 1000, stickyTop: 42}" v-else>
        <div class="filter-area">
          <div class="filter-item-area">
            <div>
              <filter-list-for-device v-for="(filterItem, index) in filterObject.filterlist"
                                      :key="'filter_' + index"
                                      :filter-item="filterItem"
                                      :filter-title="filterTitleMap[index] || filterItem.title"
                                      :filter-index="index"
                                      v-on:set-filter-query="setFilterQuery"
              />
            </div>
          </div>
        </div>
        <button type="button" @click.prevent="reload" class="refresh-txt">
          <span>새로고침</span>
          <RefreshTagListButton/>
        </button>
      </div>
    </portal>
    <template v-if="section === 'vod'">
      <infinite-scroll-series-cell-list
        v-if="cellList && cellList.length"
        :content-info="contentInfo"
        :key="'infinite-scroll-bottom-vod' + $route.fullPath"
        :cell-list="cellList"
        :thumbnail-info="thumbnailInfo"
        section="vod"
        v-on:load-more="loadMore">
        ></infinite-scroll-series-cell-list>
    </template>
    <template v-else>
      <infinite-scroll-cell-list v-if="cellList && cellList.length"
                                 :key="'infinite-scroll_bottom_all-' + $route.fullPath"
                                 :content-info="contentInfo"
                                 :cell-list="cellList"
                                 :thumbnail-info="thumbnailInfo"
                                 :container-class-name="getCellListContainerClassName"
                                 v-on:load-more="loadMore"></infinite-scroll-cell-list>
    </template>
  </div>
</template>
<script>
import InfiniteScrollCellList from '@/components/section/template/cell/InfiniteScrollCellList'
import InfiniteScrollSeriesCellList from '@/components/section/template/cell/InfiniteScrollSeriesCellList'
import { getBandTypeInfoByCellType } from '@/common/image.util'
import { get } from 'lodash'
import { CHANGE_FILTER, SORT_BY_NEWER } from '@/common/constant'
import VueSticky from 'vue-sticky'
import RefreshTagListButton from '@/assets/svg/common/ic-replay-w.svg'
import { mapMutations } from 'vuex'
import { BottomTabService, VodInfoService } from '@/common/api/api.service'
import { parse, parseUrl } from 'query-string'
import FilterListForDevice from '@/components/section/template/FilterListForDevice'
import VodFilterList from '@/components/section/template/VodFilterList'
import { EventBus } from '@/components/eventbus/EventBus'
export default {
  name: 'AllContentList',
  components: {
    InfiniteScrollSeriesCellList,
    InfiniteScrollCellList,
    RefreshTagListButton,
    FilterListForDevice,
    VodFilterList
  },
  props: {
    contentInfo: { type: Object },
    section: { type: String }
  },
  data () {
    return {
      isEmptyList: true,
      endOfList: false,
      offset: 0,
      limit: 20,
      cellList: [],
      thumbnailInfo: {},
      orderFilter: SORT_BY_NEWER,
      filterTitleMap: {},
      filterObject: {},
      genre: 'all',
      programId: get(this.contentInfo, 'programid', ''),
      contentId: '',
      orgOrderFilter: SORT_BY_NEWER
    }
  },
  directives: {
    VueSticky
  },
  computed: {
    getCellListContainerClassName () {
      return `cell-list responsive cell-${this.thumbnailInfo.type} ${this.section}`
    },
    hasFilter () {
      return this.section !== 'live'
    }
  },
  methods: {
    ...mapMutations(['showLoadingProgress', 'hideLoadingProgress']),
    setFilterQuery ({ queryString, selectedTitle, filterIndex }) {
      this.cellList = []
      this.offset = 0
      this.endOfList = false
      this.filterTitleMap[filterIndex] = selectedTitle
      this.genre = get(parse(queryString), 'genre', 'all')
      this.setData()
    },
    changeFilter (filter) {
      this.orderFilter = filter
      this.offset = 0
      this.cellList = []
      this.setData()
    },
    loadMore () {
      if (this.endOfList) return
      this.setData()
    },
    setData () {
      this.showLoadingProgress()
      const callApiFunction = BottomTabService.getContentAllApi(this.section)
      if (typeof callApiFunction === 'function') {
        callApiFunction(
          { contentID: this.contentInfo.contentid,
            programID: this.programId,
            channelID: this.contentInfo.channelid,
            offset: this.offset,
            limit: this.section === 'live' ? 200 : this.limit,
            orderBy: this.orderFilter,
            genre: this.genre
          }).then(({ data }) => {
          this.hideLoadingProgress()
          if (this.offset === 0) {
            this.filterObject = get(data, 'filter', {})
            this.thumbnailInfo = getBandTypeInfoByCellType(get(data, ['cell_toplist', 'cell_type'], ''))
          }
          let resultList = get(data, ['cell_toplist', 'celllist'], [])
          this.endOfList = resultList.length === 0
          this.isEmptyList = resultList.length === 0
          if (this.endOfList || this.isEmptyList) return
          this.offset += this.limit
          this.cellList = this.cellList.concat(resultList)
          if (this.section === 'live') {
            this.endOfList = true
          }
        })
      }
    },
    reload () {
      this.offset = 0
      this.cellList = []
      location.reload()
    }
  },
  created () {
    this.orderFilter = get(this.contentInfo, 'episodeorder', 'new')
    this.orgOrderFilter = get(this.contentInfo, 'episodeorder', 'new')
    this.setData()
    EventBus.$on(CHANGE_FILTER, (baseApi) => {
      const { url, query } = parseUrl(baseApi)
      this.programId = url.split('/').pop()
      this.limit = Number(get(query, 'limit', 10))
      this.offset = Number(get(query, 'offset', 0))
      this.cellList = []
      VodInfoService.getContentIdByProgramIdWithCatchFn({ programID: this.programId },
        () => {
          this.orderFilter = this.orgOrderFilter
          this.setData()
        }).then(({ data }) => {
        this.contentId = get(data, 'contentid', '')
        VodInfoService.getVodMetaInfo({ contentID: this.contentId }).then(({ data }) => {
          this.orderFilter = get(data, 'episodeorder', 'new')
          this.setData()
        })
      })
    })
  }
}
</script>
<style scoped>
.filter-header {
  width: 100%;
  /*height: 60px;*/
  padding: 10px 10px 0 10px;
  z-index: 600;
  box-sizing: border-box;
  text-align: right;
  font-size: 0;
}
.filter-header:after{
  display: block;
  clear: both;
  content: '';
}
.filter-header span {
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  line-height: 20px;
}
.filter-header.refresh span{
  margin-right: 0;
}
.filter-header-wrapper {
  width: 100%;
  background-color: #f7f7f7;
  height: 60px;
}
.filter-header .old-new + .old-new{
  margin-left: 16px;
}
.filter-header .old-new {
  position: relative;
  float: left;
  padding: 8px 0;
  color: #a5a5a5;
  outline: none;
}
.filter-header .old-new:first-child:after{
  position: absolute;
  content: '';
  top: 13px;
  right: -8px;
  width: 1px;
  height: 10px;
  background-color: #a5a5a5;
}
.filter-header .old-new.on {
  color: #fff;
}
.filter-area{
  float: left;
  line-height: 20px;
  padding: 8px 0;
}
</style>
